import { distanceBetween, geohashForLocation } from 'geofire-common';
import type { GeoPointLike } from '@makhe/shared';

export function computeGeohash(point: GeoPointLike): string;
export function computeGeohash(lat: number, lng: number): string;
export function computeGeohash(a: GeoPointLike | number, b?: number): string {
  if (typeof a === 'number') return geohashForLocation([a, b as number]);
  return geohashForLocation([a.latitude, a.longitude]);
}

export function distanceKm(a: GeoPointLike, b: GeoPointLike): number {
  return distanceBetween([a.latitude, a.longitude], [b.latitude, b.longitude]);
}
